import React from "react";
import { connect } from "react-redux";
import FindingsDetailView from "./FindingsDetailView";
import FindingsListView from "./FindingsListView";
import LoadingTable from "views/Components/LoadingTable";
import { styled } from "@mui/material/styles";
import { Typography, Paper, Button, Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const PREFIX = "FindingsPageView";
const classes = {
  outerContainer: `${PREFIX}-outerContainer`,
  notFoundContainer: `${PREFIX}-notFoundContainer`,
};

const Root = styled("div")(({ theme }) => ({
  [`&.${classes.outerContainer}`]: {
    padding: `0 ${theme.shape.padding}px`,
  },
  [`& .${classes.notFoundContainer}`]: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    margin: "40px auto",
    maxWidth: 600,
    padding: theme.spacing(4),
    textAlign: "center",
  },
}));

const NotFoundView = ({ dispatch, orgId }) => {
  const handleReturnToList = () => {
    dispatch({
      type: "PAGE",
      payload: {
        orgId,
        toplevel: "reporting",
        secondlevel: "findings",
      },
    });
  };

  return (
    <Paper className={classes.notFoundContainer} elevation={3}>
      <ErrorOutlineIcon color="error" sx={{ fontSize: 60 }} />
      <Typography variant="h4" color="error">
        Finding Not Found
      </Typography>
      <Typography variant="body1">
        The requested finding could not be located. It may have been removed or
        you may have followed an incorrect link.
      </Typography>
      <Box mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleReturnToList}
        >
          Return to Findings List
        </Button>
      </Box>
    </Paper>
  );
};

const renderInnerView = (props) => {
  if (props.ready) {
    if (props.isDetailsPage) {
      if (props.finding) {
        if (props.finding.length) {
          return <FindingsDetailView {...props} finding={props.finding[0]} />;
        } else {
          return <NotFoundView {...props} />;
        }
      } else {
        return <LoadingTable isMaterial />;
      }
    } else {
      return <FindingsListView {...props} />;
    }
  }
  return <LoadingTable isMaterial />;
};

const FindingsView = (props) => {
  return (
    <Root className={classes.outerContainer}>{renderInnerView(props)}</Root>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    license: state.license,
    isDetailsPage: !!state.location.payload.id1,
    orgId: state.page.payload.orgId,
  };
};

export default connect(mapStateToProps)(FindingsView);
